export default __webpack_public_path__ + "static/media/logo.6fc634c2.svg";